import React from 'react';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';

const MyForm = React.forwardRef((props, ref) => {
  const { children, onSubmit, initialData } = props;

  return (
    <Form ref={ref} onSubmit={onSubmit} initialData={initialData}>
      {children}
    </Form>
  );
});

MyForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialData: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.node.isRequired,
};

MyForm.defaultProps = {
  initialData: {},
};

export default MyForm;
